module.exports = __webpack_public_path__ + "static/media/confirm-company.cb16a7d4.svg";